<template>
  <div>
    <el-dialog
      title="Wybierz wideo"
      append-to-body
      class="videos-dialog"
      width="80vw"
      :visible.sync="dialogFormVisible"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="Wybierz" name="select">
          <select-tab @submit="submitVideo" />
        </el-tab-pane>
        <el-tab-pane label="Prześlij" name="upload">
          <upload-tab ref="uploadTab" @submit="uploadVideo" />
          <el-progress v-show="uploadProgress" :percentage="uploadProgress" />
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Anuluj</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import UploadTab from './UploadTab'
import SelectTab from './SelectTab'
import { Video } from '@/api'

export default {
  components: {
    SelectTab,
    UploadTab
  },
  data() {
    return {
      activeName: 'select',
      dialogFormVisible: false,
      uploadProgress: 0
    }
  },
  methods: {
    uploadVideo(video) {
      try {
        Video.save({ file: video }, this.onUploadProgress)
          .then(response => {
            this.submitVideo(response.data.id)
          })
          .catch(error => {
            this.uploadError(error)
          })
      } catch (e) {
        console.log('catch')
        console.log(e)
      }
    },
    onUploadProgress(progressEvent) {
      const progress = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      this.uploadProgress = parseInt(progress)
    },
    submitVideo(video) {
      this.$emit('submit', video)
      this.dialogFormVisible = false
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },

    uploadError(error) {
      let message = 'Wystąpił problem podczas wysyłania pliku.'

      if (error.response.status == 413) {
        message = 'Wgrywane wideo ma za duży rozmiar.'
      }

      this.$refs.uploadTab.clear()

      this.$message({
        message: message,
        type: 'error'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.videos-dialog {
  z-index: 775666 !important;
}
</style>
